<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="page_b"></a><span class="strong"><span class="smallcaps">ALSO BY FRANCES WILSON</span></span></p>
<p class="center"><em class="italic">Literary Seductions<br/>The Courtesan’s Revenge</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// aboutauthor.vue?f5177d16